import { render, staticRenderFns } from "./DataBrowser.vue?vue&type=template&id=29a88792&scoped=true"
import script from "./DataBrowser.vue?vue&type=script&lang=ts"
export * from "./DataBrowser.vue?vue&type=script&lang=ts"
import style0 from "./DataBrowser.vue?vue&type=style&index=0&id=29a88792&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a88792",
  null
  
)

export default component.exports